import React, {useEffect} from "react";
import 'components/editor_canvas/editor_canvas_style.css'
import {useDrop} from 'react-dnd';
import Types from 'components/editor_canvas/editor_canvas_element_types';
import PlacedItem from "components/placed_item";
import {FontStyles} from "components/constants";
import {Span} from "components/common_style/text";
import {Flex} from "components/common_style/flex";
import {TITLE_LAYOUT_A, TITLE_LAYOUT_B, TITLE_LAYOUT_C} from "pages/story_editor/story_editor";

function EditorCanvasView(props) {
    const [{}, drop] = useDrop({
        accept: [
            Types.ELEMENT],
        begin: (m) => props.onDragStart(),
        drop: (item, monitor) => {
            switch (item.type) {
                case Types.ELEMENT:
                    props.onDrop(item, monitor);
                    break;
            }
        },
    });
    return <div className={props.printable ? 'editor-canvas-container-print' : 'editor-canvas-container'}
                ref={(ref) => {
                    drop(ref);
                    props.canvasRef.current = ref;
                }}
                style={{
                    boxSizing: 'content-box',
                    backgroundImage: 'url("' + props.bgImage + '")',
                    maxWidth: props.printable ? null : props.maxWidth || '177.78vh',
                    maxHeight: props.printable ? null : props.maxHeight || '100vh',
                    width: props.width || '100vw',
                    height: props.height || '56.25vw',
                    bottom: !!props.bottomOffset ? props.bottomOffset : 0,
                    ...(props.printable ? {
                        width: props.canvasRect.width,
                        backgroundSize: props.canvasRect.width,
                        height: props.canvasRect.height,
                        position: "relative"
                    } : {})
                }}>
        {Object.entries(props.placedItems).map(([k, v]) => {
            return <PlacedItem
                onClick={() => props.onPlacedItemClick(v.uuid)}
                key={'ecv-' + k}
                canvasRect={props.canvasRect}
                placedItem={v}
                printable={props.printable}
                readOnly={props.readOnly}
                transform={!props.readOnly && props.editedItemUuid === v.uuid}
                canvasOffsetX={props.canvasOffsetX}
                canvasOffsetY={props.canvasOffsetY}
                onTransformStart={props.onTransformStart}
                onTextFocus={props.onTextFocus}
                onTransformEnd={props.onTransformEnd}
                onTitleUpdate={props.onTitleUpdate}
            />
        })}
        {props.pageN === 0 ? <Flex column style={getTitleStyle(props.titleLayout !== undefined ? props.titleLayout : props.storyData.titleLayout)}>
            <Span textStyle={!!props.printable ? FontStyles.storyTitlePrint : FontStyles.storyTitle} style={{
                textShadow: '0px 0px 10px #000000',
                marginBottom: 10
            }}>{props.storyData.title}</Span>
            <Span textStyle={!!props.printable ? FontStyles.authorPrint : FontStyles.author} style={{
                textShadow: '0px 0px 10px #000000',
            }}>{props.storyData.author}</Span>
        </Flex> : null}
    </div>;
}

function getTitleStyle(style) {
    let base = {
        pointerEvents: 'none',
        justifyContent: 'center',
        position: 'absolute',
        zIndex: 999,
    };
    let padding = '10%';
    console.log(style);
    switch (style) {
        case TITLE_LAYOUT_B:
            return {
                alignItems: 'center',
                justifyContent: 'flex-end',
                left: padding,
                right: padding,
                bottom: padding,
                ...base
            };
        case TITLE_LAYOUT_C:
            return {
                alignItems: 'flex-start',
                top: padding,
                bottom: padding,
                left: padding,
                right: padding,
                ...base
            };
        case TITLE_LAYOUT_A:
        default:
            return {
                alignItems: 'center',
                right: padding,
                left: padding,
                top: padding,
                bottom: padding,
                ...base
            };
    }
}

export default EditorCanvasView;
